import React from "react";
import '../../assets/css/Profile.css';
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";

const ChooseLanguage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const languages = [
    { code: "es", name: t("spanish"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Flag_of_Spain.svg/32px-Flag_of_Spain.svg.png" },
    { code: "fr", name: t("french"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Flag_of_France.svg/32px-Flag_of_France.svg.png" },
    { code: "en", name: t("english"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_the_United_States.svg/32px-Flag_of_the_United_States.svg.png", active: true },
    { code: "ja", name: t("japanese"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Flag_of_Japan.svg/32px-Flag_of_Japan.svg.png" },
    { code: "ko", name: t("korean"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Flag_of_South_Korea.svg/32px-Flag_of_South_Korea.svg.png" },
    { code: "zh", name: t("chinese"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Flag_of_China.svg/32px-Flag_of_China.svg.png" },
    { code: "uk", name: t("ukrainian"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Flag_of_Ukraine.svg/32px-Flag_of_Ukraine.svg.png" },
    { code: "de", name: t("german"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Flag_of_Germany.svg/32px-Flag_of_Germany.svg.png" },
    { code: "ru", name: t("russian"), flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Flag_of_Russia.svg/32px-Flag_of_Russia.svg.png" },
  ];

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div>
      <div className="row justify-content-center">
        <div className="p-4 choose-language-container">
          <div className="row">
            <div className="col-lg-5 d-flex justify-content-between" style={{ marginBottom: '25px' }}>
              <div className="mb-4 text-center" style={{ fontSize: '20px', fontWeight: '600' }}>{t("choose_language")}</div>
            </div>
          </div>
          <ul className="list-group row ">
            {languages.map((language, index) => (
              <li
                key={index}
                className={`list-group-item d-flex align-items-center border col-lg-6 ${index !== languages.length - 1 ? "mb-4" : ""} ${language.active ? "activate" : ""}`}
                style={{ maxWidth: '340px', cursor: 'pointer' }}
                onClick={() => changeLanguage(language.code)}
              >
                <span className="me-3">
                  <img src={language.flag} alt={language.name} width="24" height="16" />
                </span>
                {language.name}
              </li>
            ))}
          </ul>
          <div className="text-center choose-language-button">
            <CustomButton
              buttonText={t("save")}
              className="border"
              style={{
                width: "100%",
                height: "48px",
                borderRadius: "12px",
                background: "#006FFD",
                color: "#FFFFFF",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseLanguage;
